import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { UserService } from 'src/app/shared/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'] 

})
export class EmailVerificationComponent {

  verificationStatus: string = '';
  isError: boolean = false;

  constructor(
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService
  ) { }

  ngOnInit(): void {
    // Capture the 'email' and 'token' from the URL query parameters
    this._activeRoute.queryParams.subscribe(params => {
      const email = params['email'];
      const token = params['token'];

      if (email && token) {
        this.handleEmailVerification(email, token);
      } else {
        this.verificationStatus = 'Invalid email verification link.';
        this.isError = true;
        this.redirectAfterDelay();
      }
    });
  }

  // #region Fire HTTP Requests
private fireEmailVerificationRequest(apiService: ApiService, email: string, token: string) {
  const keyValueParams = { email: email, token: token };
  let req$ = apiService.post(
    AppConstants.CONTROLLERS.ACCOUNT, 
    AppConstants.ACTIONS.VerifyEmail, 
    true, 
    environment.APIs_PREFIX, 
    keyValueParams
  );
  return lastValueFrom(req$);
}
// #endregion

    //#region API Service
    private createApiService(): ApiService {
      const apiService = new ApiService(this._http);
      apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
      return apiService;
    }
    //#endregion

private async handleEmailVerification(email: string, token: string) {
  console.log('handleEmailVerification called with email and token:', email, token); // Debug log
  this._loaderService.showLoader();
  const apiService = this.createApiService();
  
  this.fireEmailVerificationRequest(apiService, email, token)
    .then((response: any) => {
      let result = response as unknown as BaseResponseDTO;
      if (result.isSuccess) {
         this._router.navigate(
            [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.SUCCESS],
            { state: { message: 'Registration Successful' } }
          );
      } else {
        console.log('handleEmailVerification error:', result);
        this.verificationStatus = result.errorMessageEn || 'Verification failed.';
        this.isError = true;
        this.redirectAfterDelay();
      }
    })
    .catch((err: HttpErrorResponse) => {
      this._loaderService.hideLoader();
      this.verificationStatus = 'An error occurred during verification.';
      this.isError = true;
      this.redirectAfterDelay();
    })
    .finally(() => {
      this._loaderService.hideLoader();
    });
}

private redirectAfterDelay(): void {
  setTimeout(() => {
    this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
  }, 5000); // Redirect after 5 seconds
}

redirectNow(): void {
  this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
}

}


